import type { ReactNode } from "react";
import { motion } from "motion/react";

const AnimatePop = ({
  children,
  delay = 0,
}: {
  children: ReactNode;
  delay?: number;
}) => {
  const initialStyle = {
    opacity: 0,
    scale: 0,
  };
  return (
    <motion.div
      initial={initialStyle}
      animate={{
        opacity: 1,
        scale: [0, 1.3, 1],
      }}
      exit={initialStyle}
      transition={{ duration: 0.3, delay }}
    >
      {children}
    </motion.div>
  );
};

export { AnimatePop };
